<template>
  <div class="layout-container">
    <main>
      <router-view :key="key" />
    </main>
    <van-tabbar route active-color="var(--mainColor)">
      <van-tabbar-item to="/app" icon="wap-home">应用中心</van-tabbar-item>
      <van-tabbar-item to="/user" icon="manager">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
const { jumpURL } = projectConfig
import { getConfigInfoApi, getAppListApi, getUserInfoApi } from './api'
export default {
  name: 'Layout',
  data() {
    return {
      baseUrl: '',
      appList: [],
      userInfo: {}
    }
  },
  beforeCreate() {
    // 设备类型
    const isMobile = /Mobile|Android|iPhone/i.test(navigator.userAgent)
    if (!isMobile) return window.location.href = jumpURL
  },
  async created() {
    const { data: data1 } = await getConfigInfoApi('minio_baseUrl')
    this.baseUrl = data1.settingValue
    const { data: { userOperationList } } = await getAppListApi()
    this.appList = userOperationList
    const { data } = await getUserInfoApi()
    this.userInfo = data
    localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
  },
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  position: relative;
  height: 100vh;

  main {
    background: #f7f7f7;
    height: calc(100vh - 70px);
  }

  .van-tabbar {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 10px 0;
  }
}
</style>